import React from 'react'
import './MobPartner.css'
import microsoft from './../../../Assets/partners/microsoft.png'
import allianz from './../../../Assets/partners/allianz.png'
import upwork from './../../../Assets/partners/upwork.png'
import volvo from './../../../Assets/partners/volvo.png'
import grab from './../../../Assets/partners/grab.png'
import verizon from './../../../Assets/partners/verizon.png'
import coinbase from './../../../Assets/partners/coinbase.png'
import expedia from './../../../Assets/partners/expedia.png'
import airtable from './../../../Assets/partners/airtable.png'
import magneto from './../../../Assets/partners/magneto.png'
import carrera from './../../../Assets/partners/carrera.png'
import bonanza from './../../../Assets/partners/bonanza.png'
import wetransfer from './../../../Assets/partners/wetransfer.png'
import suzuki from './../../../Assets/partners/suzuki.png'
import algolia from './../../../Assets/partners/algolia.png'
import heineken from './../../../Assets/partners/heineken.png'

function MobPartner() {
    return (
        <div id='MobPartner_lan'>
            <h1>SheildScan make +1000 Startup secure</h1>
            <div className='Mobpartner_section_container'>
                <div className='Mobpartner_section_box'>
                    <img src={microsoft} />
                    <img src={allianz} />
                </div>
                <div className='Mobpartner_section_box'>
                    <img src={upwork} />
                    <img src={volvo} />
                </div>
                <div className='Mobpartner_section_box'>
                    <img src={grab} />
                    <img src={verizon} />
                </div>
                <div className='Mobpartner_section_box'>
                    <img src={coinbase} />
                    <img src={expedia} />
                </div>
                <div className='Mobpartner_section_box'>
                    <img src={airtable} />
                    <img src={magneto} />
                </div>
                <div className='Mobpartner_section_box'>
                    <img src={carrera} />
                    <img src={bonanza} />
                </div>
                <div className='Mobpartner_section_box'>
                    <img src={wetransfer} />
                    <img src={suzuki} />
                </div>
                <div className='Mobpartner_section_box'>
                    <img src={algolia} />
                    <img src={heineken} />
                </div>
            </div>
        </div>   
    )
}

export default MobPartner
